import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AlertTriangle } from "lucide-react";

export default function ChallanGaps() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/challans/series").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6">
      {(data?.series || []).map((s) => (
        <div key={s.series} className="card-flat">
          <div className="p-4 border-b border-gray-200 flex items-center justify-between">
            <div>
              <div className="small-label text-gray-500">Series</div>
              <div className="font-heading font-black text-2xl">
                {s.series === "default" ? "(No series)" : s.series}
                <span className="ml-3 text-sm font-normal text-gray-500">#{s.min} → #{s.max} · {s.count} entries</span>
              </div>
            </div>
            {s.missing.length > 0 && (
              <div className="flex items-center gap-2 text-[#B91C1C] bg-[#FEE2E2] px-3 py-1.5 rounded-sm border border-[#FECACA]">
                <AlertTriangle size={16} />
                <span className="text-sm font-bold">{s.missing.length} missing</span>
              </div>
            )}
          </div>
          {s.missing.length > 0 && (
            <div className="p-4 border-b border-gray-200">
              <div className="small-label text-gray-500 mb-2">Missing challan numbers</div>
              <div className="flex flex-wrap gap-1.5">
                {s.missing.map((n) => (
                  <span key={n} className="data-num text-sm px-2 py-1 stock-mt rounded-sm">{n}</span>
                ))}
              </div>
            </div>
          )}
          <div className="table-wrap">
          <table className="table-dense w-full">
            <thead>
              <tr><th className="text-left">Challan</th><th className="text-left">Date</th><th className="text-left">Type</th></tr>
            </thead>
            <tbody>
              {s.txns.map((t) => (
                <tr key={t.id}>
                  <td className="data-num font-bold">{t.challan_no}</td>
                  <td className="data-num text-xs">{t.date}</td>
                  <td className="capitalize">{t.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ))}
      {(!data?.series || data.series.length === 0) && (
        <div className="card-flat p-8 text-center text-gray-400 text-sm">No challans recorded yet</div>
      )}
    </div>
  );
}
